var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlockCombinationKeyGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "24px",
    viewBox: "0 0 29 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unlock_combination_key_blue",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 1.000000)",
    fill: "#727272",
    fillRule: "nonzero",
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ctrl",
    fontSize: 5
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }, "Ctrl"))), /*#__PURE__*/React.createElement("g", {
    id: "Z",
    transform: "translate(17.130396, 10.071860)",
    fontSize: 6
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6
  }, "Z")))), /*#__PURE__*/React.createElement("path", {
    d: "M14.009434,0 C14.7831536,0 15.4836253,0.314962468 15.9906671,0.824187893 C16.4977089,1.33341332 16.8113208,2.03690169 16.8113208,2.81395349 L16.8113208,2.81395349 L16.8113208,7.1627907 L24.1981132,7.1627907 C24.9718328,7.1627907 25.6723045,7.47775317 26.1793463,7.98697859 C26.6863882,8.49620402 27,9.19969242 27,9.97674419 L27,9.97674419 L27,19.1860465 C27,19.9630983 26.6863882,20.6665867 26.1793463,21.1758121 C25.6723045,21.6850376 24.9718328,22 24.1981132,22 L24.1981132,22 L14.009434,22 C13.2357143,22 12.5352426,21.6850376 12.0282009,21.1758121 C11.521159,20.6665867 11.2075472,19.9630983 11.2075472,19.1860465 L11.2075472,19.1860465 L11.2075472,15.8604651 L2.80188679,15.8604651 C2.02816712,15.8604651 1.32769542,15.5455027 0.82065364,15.0362772 C0.313611857,14.5270518 0,13.8235634 0,13.0465116 L0,13.0465116 L0,2.81395349 C0,2.03690169 0.313611857,1.33341332 0.82065364,0.824187893 C1.32769542,0.314962468 2.02816712,0 2.80188679,0 L2.80188679,0 L14.009434,0 Z",
    id: "Combined-Shape",
    stroke: "#727272",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5415274,7.19636968 L14.5655249,7.19770029 L14.5655249,7.19770029 L17.7438549,7.19770029 L22.9094465,7.19770029 C25.062047,7.09366309 26.8914133,8.75435176 26.9954505,10.9069523 C26.998483,10.9696985 27,11.0325088 27,11.0953283 L27,18 C27,20.209139 25.209139,22 23,22 L15.2203533,22 C13.0282658,22 11.2512278,20.222962 11.2512278,18.0308745 C11.2512278,17.94972 11.2537168,17.8685845 11.2586912,17.7875826 L11.2586912,17.7875826 L11.2586912,17.7875826 L11.2586912,13.6092043 L11.2586912,11 L11.2586912,10.5375212 C11.1330789,8.8198118 12.4237285,7.32550429 14.1414379,7.19989194 C14.2745882,7.19015495 14.4082263,7.18897844 14.5415274,7.19636968 Z",
    id: "Rectangle",
    stroke: "#727272",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockCombinationKeyGray);
export default __webpack_public_path__ + "static/media/unlock_combination_key_gray.ab46f9053757983e10b6e2fbbc5e47c5.svg";
export { ForwardRef as ReactComponent };